import Cookie from 'cookie-universal'
import { Tier, TiersService } from '@mc/api'

let tiers: Array<Tier>

export interface ProductsQueryParams {
  discountSlug?: string
  gift?: boolean
}

export const getTiersAsync = async (
  params?: ProductsQueryParams,
  refresh = false,
) => {
  if (!!tiers && !refresh) {
    return tiers
  }
  const collapsedBucket = getCollapsedPaintedDoorBucket()
  const collapsedV2Bucket = getCollapsedPaintedDoorV2Bucket()
  const pricingI18nT3Bucket = getPricingI18nT3Bucket()
  const pdSingleClassBucket = getPaintedDoorSingleClassBucket()
  const response = await TiersService.getCurrentTierCollection({
    deep: true,
    ...params,
    ...(collapsedBucket && { collapsedBucket }),
    ...(collapsedV2Bucket && { collapsedV2Bucket }),
    ...(pricingI18nT3Bucket && { pricingI18nT3Bucket }),
    ...(pdSingleClassBucket && { pdSingleClassBucket }),
  })

  tiers = response.pricingTiers.map((tier) => ({
    ...tier,
    product: {
      ...tier.product,
      displayMonthlyPrice: tier?.product?.monetizedYearPricePerMonth,
      displayMonthlyPriceWithDiscount:
        tier?.product?.monetizedYearPricePerMonthDiscounted,
    },
  }))

  return tiers
}

// prcng-107_v1 experiment
const getCollapsedPaintedDoorBucket = () => {
  const cookies = Cookie()

  return cookies.get('collapsed_bucket') as string | undefined
}

// prcng-521_v2 experiment
const getCollapsedPaintedDoorV2Bucket = () => {
  const cookies = Cookie()

  return cookies.get('collapsed_v2_bucket') as string | undefined
}

// prcng-606_v1 experiment
const getPricingI18nT3Bucket = () => {
  const cookies = Cookie()

  return cookies.get('pricing_i18n_t3') as string | undefined
}

// pen-5780_v1 experiment
const getPaintedDoorSingleClassBucket = () => {
  const cookies = Cookie()

  return cookies.get('pd_single_class_bucket') as string | undefined
}
